import { RedditUsersListQueryItems, UserAccessEntityType } from 'wb-reddit/graphql/generated';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { isSpotify } from '@aleph/shared-components';

export const REFRESH_TOKEN_URI = `${import.meta.env.VITE_API_PATH}/auth/refresh-token/pn_re/user/`;

export const NETWORK = 'pn_tw';

export type AccessBadgeEntityType = {
	name?: string | null,
	type?: string | null
};

export const getPublicClient = ({ uri }: { uri: string }) => new ApolloClient({
	uri,
	cache: new InMemoryCache(),
});

export const getEntityTypeName = (type?: UserAccessEntityType) => {
	// TODO add business
	if (isSpotify()) {
		return 'Advertiser';
	}

	switch (type) {
		case UserAccessEntityType.Agency:
			return 'Advertiser';
	}

	return 'Ad Account';
};

export const getUserInitials = (
	user?: RedditUsersListQueryItems | null,
) => (user ? `${user.userName?.[0] ?? ''}${user.userSurname?.[0] ?? ''}` : '');
